module.exports = __webpack_public_path__ + "img/cs-protrain-1.e8a39955.jpg";